<template>
  <canvas id="twoDimCanvas" ref="canvas" :width="width" :height="height">
  </canvas>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 600
    },
    height: {
      type: Number,
      default: 300
    }
  },
  data () {
    return {
      context: null
    }
  },
  inject: ['automaton', 'config'],
  computed: {
    cellSize () {
      return this.width / this.automaton.width
    }
  },
  methods: {
    clearCanvas() {
      this.context.clearRect(0, 0, this.width, this.height)
      this.context.fillStyle = this.config.deadColor
      this.context.fillRect(0, 0, this.width, this.height)
    },
    drawWorld (lattice) {
      this.clearCanvas()
      this.context.fillStyle = this.config.aliveColor
      lattice.forEach((row, y) => {
        row.forEach((cell, x) => {
          if (cell === 1) {
            this.context.fillRect(x*this.cellSize ,
                                  y*this.cellSize,
                                  this.cellSize,
                                  this.cellSize)
          }
        })
      })
    }
  },
  mounted () {
    this.context = this.$refs.canvas.getContext('2d')
    this.automaton.on('updated', ({lattice}) => {
      this.drawWorld(lattice)
    })
    this.clearCanvas()
  }
}
</script>

<style scoped>
#twoDimCanvas {
  border: 2px solid #999;
}
</style>
